module.exports = __webpack_public_path__ + "stylesheets/section-company-quote_c3058a7abffcc0071f36f4e6ccc8f55e.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/sections/section-company-quote.less
// module id = 7f+t
// module chunks = 153